import { get, post } from '../../../../services/request';

export const fetchMyLinks = (includeRevoked) =>
    get(`Schedule/Share/MyLinks${includeRevoked ? '?includeRevoked=true' : ''}`);

export const revokeLink = (shareLinkId) =>
    post('Schedule/Share/Revoke', { ShareLinkID: shareLinkId });

export const generateLink = (payload) =>
    post('Schedule/Share/Generate', payload);
